import Api from '@/api'

export default {
  namespaced: true,

  state: {
    homeData: [],
  },

  mutations: {
    setData(state, data) {
      state.homeData = data
    },

    clearData(state) {
      state.homeData = []
    },
  },

  actions: {
    async getHomeData({ commit }) {
      const { data } = await Api.get('home-page')
      commit('clearData')

      if (data) {
        commit('setData', data)
      }

      return data
    },
  },

  getters: {
    homeData(state) {
      return state.homeData
    },
  },
}
